import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async countries() {
    return await this.call('/spa/world/countries', {
      method: 'get',
    })
  }

  async states(cid: number) {
    return await this.call(`/spa/world/countries/${cid}/states`, {
      method: 'get',
    })
  }

  async cities(cid: number, sid: number) {
    return await this.call(`/spa/world/countries/${cid}/states/${sid}/cities`, {
      method: 'get',
    })
  }
}
